import Flex from "common/Boxes/Flex";
import Text from "common/Typography/Text";
import React, { CSSProperties, useMemo } from "react";
import TextWithIcon from "common/Text/TextWithIcon";
import { typography } from "@shared/common/Themes/typography";
import useNextOrder from "@shared/common/LiveComponents/useNextOrder";
import { SharedNextOrderProps } from "@shared/services/socket/types";
import { DOLLAR_COINS } from "@shared/common/constants";

interface NextOrderProps extends SharedNextOrderProps {
  style?: CSSProperties;
  textStyle?: CSSProperties;
}

const NextOrder = ({
  symbol,
  exchange,
  nextOrder,
  orderType,
  isMobile,
  isPriceSecondary,
  style,
  textStyle,
}: NextOrderProps) => {
  const { pair, priceText, priceProps, color, distanceText } = useNextOrder({
    symbol,
    exchange,
    nextOrder,
    orderType,
  });

  const getPrice = () => {
    if (!pair) return priceText;
    return DOLLAR_COINS.includes(pair) ? (
      `$${priceText}`
    ) : (
      <TextWithIcon
        {...priceProps}
        textStyle={{ height: 18 }}
        iconStyle={{ marginRight: 4 }}
      />
    );
  };

  const price = useMemo(() => {
    return (
      <Text
        type={isPriceSecondary ? "secondary" : undefined}
        $size={typography.fontSizes.S}
        as="div"
        style={{ display: "flex", alignItems: "center", ...textStyle }}
      >
        {getPrice()}
      </Text>
    );
  }, [isPriceSecondary, priceProps, textStyle?.color]);

  const distance = useMemo(() => {
    return (
      <Text
        $size={typography.fontSizes.M}
        $weight={typography.fontWeights.MEDIUM}
        style={{
          marginLeft: isMobile ? 0 : 6,
          color,
        }}
      >
        {distanceText}
      </Text>
    );
  }, [distanceText, color, isMobile]);

  if (!nextOrder)
    return (
      <Text type="secondary" style={textStyle}>
        N/A
      </Text>
    );

  return (
    <Flex
      $flexDirection={isMobile ? "column-reverse" : "row"}
      $alignItems="center"
      $justifyContent="flex-start"
      style={style}
    >
      {price}
      {distance}
    </Flex>
  );
};

export default React.memo(NextOrder);
